import { AttentionTypes } from '../../Definitions'
import { Pages } from '../../Navigation/root'
import { LangFile } from './'

const Texts:LangFile = {
  // #region | General
  additional: "additional", 
  and: "and",
  change: "change",
  choose: "choose",
  deleteFailed: "delete failed", 
  editFailed: "edit failed", 
  filterBy: "filter by",
  from: "from",
  general: "general", 
  no: "no",
  noData: "No Data",
  noOptions: "No Options",
  of: "of",
  off: "off",
  on: "on",
  optional: "optional",
  page: "page",
  reset: "reset",
  required: "required",
  saveAlert: "Please save or cancel edit view.",
  search: "Search",
  select: "Select",
  success: "Success",
  to: "to",
  unknown: "unknown", 
  wasUpdated: "was updated", 
  wasDeleted: "was deleted", 
  useSelectedTime: "use selected time",
  yes: "yes",
  // #endregion

  // Regarding the language list:
  // Please translate only your own language. 
  // If your language is not on the list, then add it using a maximum of two 
  // initials followed by a colon and the language in quotation marks.
  languages: { 
    en: "english",
    dk: "dansk",
    es: "español",
    de: "deutsch",
    ma: "普通话",
    ko: "한국어",
    nl: "nederlands",
  },

  cookie: {
    header: "cookies",
    context1: "Agrisys A/s use cookies for the following purposes:",
    context2: "By pressing “Accept all” you accept our use of cookies. Else a minimun of cookies will be used required by the service to function, for example to manage login, and data fetching from the consys platfrom.",
    purpose1: "To support the website's functionality, for example by remembering your settings regarding cookies, preferred languages, currencies, etc.",
    purpose2: "To perform statistical analysis of your use of the website, for example by measuring what type of content you are looking at and clicking on.",
    accept: "Accept necessary",
    acceptAll: "Accept All"
  },

  // #region | Units
  units: {
    animal: "animal",
    animals: "animals",
    units: "units",
    capacity: "capacity",
    cup: "cup", 
    cups: "cups", 
    date: "date",
    day: "day",
    days: "days",
    g: "g",
    hour: "hour",
    hourAgo: "hour ago",
    hours: "Hours",
    hoursAgo: "aours ago",
    kg: "KG",
    minutAgo: "minut ago",
    minutesAgo: "minutes ago",
    min: "min",
    milisec: "milisec", 
    pct: "PCT",
    sec: "sec", 
    time: "time",
    times: "times",
    timeToday: "time today",
    timesToday: "times today",
    total: "total",
    energy: "energy",
    gramPerMinute: "gram per minute",
    lenght: "lenght"
  },
  // #endregion

  // #region | Buttons
  buttons: {
    add: "add",
    apply: "apply",
    cancel: "cancel",
    commit: "commit",
    confirm: "confirm",
    create: "create",
    csv: "csv",
    deselectAll: "deselect all",
    details: "details",
    edit: "edit",
    excel: "excel",
    filter: "Filter",
    goBack: "go back",
    menu: "menu",
    move: "move",
    next: "next",
    options: "options",
    prev: "prev",
    print: "print",
    resetFilters: "reset filters",
    save: "save",
    selectAll: "select all",
    unit: "unit",
    close: "close",
  },
  // #endregion

  // #region | Menu Headers
  menuHeaders: {
    overview: "overview",
    globalMenu: "global menu",
    systemMenu: "system menu",
    attentions: "attentions",
    quickEntry: "quick entry",
    language: "language",
    [Pages.dashboard]: "dashboard",
    [Pages.kpi]: "kpi",
    [Pages.feedCurve]: "feed curve",
    [Pages.feedCurves]: "feed curves",
    [Pages.components]: 'components',
    [Pages.componentsAlternatives]: "component alternatives",
    [Pages.mixtures]: "mixtures",
    [Pages.silos]: "silos",
    [Pages.silosSettings]: "silo Settings",
    [Pages.animal]: "animal",
    [Pages.animals]: "animals",
    [Pages.animalsGroups]: "animal groups",
    [Pages.reports]: "reports",
    [Pages.archive]: 'archive',
    [Pages.logbook]: "logbook",
    [Pages.globalSettings]: "settings",
    [Pages.devices]: "devices",
    [Pages.freeda_lf]: "overview",
    [Pages.freeda_lf_sections]: 'locations', // OBS: CHANGED FROM SECTIONS 24/02/2026 !!!!!!!!!!
    [Pages.freeda_lf_settings]: 'settings',
    [Pages.op_operations]: 'operations',
    [Pages.op_quickEntry]: 'Quick Entry',
    [Pages.freeda_esf]: "overview",
    [Pages.freeda_esf_sections]: "locations", // OBS: CHANGED FROM SECTIONS 24/02/2026 !!!!!!!!!!
    [Pages.freeda_esf_settings]: "settings"
  },
  // #endregion

  // #region | User
  user: {
    userInformation: "user information",
    user: "user",
    userName: "User Name",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone",
    email: "Email",
    password: "Password",
    repeatPassword: "Repeat password",
    country: "Country",
    address: "Address"
  },
  // #endregion

  // #region | Farm
  farm: {
    farmInformation: "farm information",
    farmName: "farm name",
    city: "city",
    street: "street",
    phone: "phone",
    vat: "vat",
    email: "email"
  },
  // #endregion

  // #region | Milestones
  milestones: {
    general: {
      milestone: "milestone",
      milestones: "milestones",
      noMilestoneFound: "no milestone found",
      animalsInMilestones: "animals in milestones",
      latestMilestone: "curr. milestone",
      milestoneDay: "curr. milestone day",
      newMilestone: "New milestone"
    },
    defaultMilestones: {
      farrowing: "Farrowing",
      insemination: "Insemination",
      weaning: "Weaning",
      movedToFarrowing: "Moved To Farrowing"
    }
  },
  // #endregion

  // #region | Events
  events: { 
    events: "events", 
    eventType: "type", 
    eventDate: "date", 
    eventNote: "note", 
    eventTime: "time", 
    typeMissing: "type missing", 
    dateMissing: "date missing", 
    noteMissing: "note missing", 
    addEvent: "add event",
    animal: "animal", 
  },
  // #endregion

  // #region | Devices
  devices: {
    devices: "devices",
    name: "name",
    cpuId: "CPU ID",
    type: "Type",
    connection: "connection",
    system: "system",
    noControllersFound: "no lan controllers found",
    lanControllers: "lan controllers",
    newLcBoard: "new LC board",
    boardName: "board name",
    boardNameMissing: "board name missing",
    powerSupplyMissing: "power supply missing",
    maxAcPortsMissing: "max ac ports missing", 
    noIoBoards: "no I/O boards found",
    ioBoards: "I/O boards",
    newIoBoard: "new I/O board",
    layout: "layout",
    horizontal: "Horizontal",
    vertical: "Vertical",
    asc: "Ascending",
    desc: "Descending",
    columns: "columns",
    rows: "rows",
    order: "order",
    direction: "direction",
    chooseIo: "Choose I/O",
    chooseRfidIo: "Choose RFID Reader I/O", 
    remainingInputs: "remaining inputs",
    remainingOutputs: "remaining outputs",
    aicoIo: "I/O Boards",
    output: "Output",
    input: "Input",
    board: "board",
    moveBoard: "move board",
    noTerminals: "No Terminals",
    terminalPort: "Terminal Port",
    pen: "Pen",
    ioSpecifications: "I/O specifications",
    numbering: "numbering",
    manual: "manual",
    automatic: "automatic",
    pattern: "pattern",
    topLeft: "top left",
    topRight: "top right",
    bottomLeft: "bottom left",
    bottomRight: "bottom right",
    startCorner: "start corner",
    noLanController: "No Lan controller",
    noCpuId: "No CPU ID",
    noSystem: "No system",
    server: "Server"
  },
  // #endregion

  // #region | System Controls
  systemControls: {
    general: {
      startSystem: "start system",
      systemControls: "system controls",
      emergencyStop: "emergency stop",
      stopSystem: "stop system",
      startAll: "start all",
      startSection: "start section",
      startSelected: "start selected",
      calibrateSection: "calibrate section",
      calibrateSelected: "calibrate selected",
      emptySection: "empty section",
      emptySelected: "empty selected",
      clickPen: "Click every pen you want to select",
      clickStation: "Click every station you want to select",
      unClickPen: "Click every pen you want to deselect",
      orSelectAll: "Or select all",
      orDeselectAlle: "Or deselect all",
      problem: "problem",
      problems: "problems",
      warning: "warning",
      warnings: "warnings",
      attention: "attention",
      attentions: "attentions",
      attentionType: "Attention type",
      systemState: "System state",
      staticFeeding: "Static feeding",
      nextFeeding: "Next feeding",
      resolvedWeight: "resolved weight",
      noPensSelected: "No pens selected",
      noStationsSelected: "No stations selected", 
      feeding: "Feeding",
      feedingFailed: "Feeding failed",
      calibrating: "Calibrating",
      calibratingFailed: "Calibrating failed",
      changeTime: "Change time",
      emptying: "Emptying",
      emptyingFor: "Emptying for",
      emptyingFailed: "Emptying failed",
      controls: "Controls",
      confirmStop: "Would you like to proceed the emergency stop of the system",
      goToSystem: "go to system",
      systemStatus: "system status",
      date: "date",
      level: "level",
      type: "type",
      inspect: "inspect",
      delete: "delete",
      logid: "log ID",
      system: "System",
      motor: "Motor",
      animal: "Animal",
      alerts: "alerts",
      location_name: "Location Name",
      fk_lan_controllers: "FK Lan Controllers",
      lan_controller_log_id: "Lan Controller Log ID",
      attention_message: "Attention Message",
      attention_time: "Attention Time",
      runningWith: "running with",
      technicalData: "Technical data",
      startLocation: "start location", 
      calibrateLocation: "calibrate location", 
      gateControl: "gate control", 
      autotuneAntenna: "autotune antenna",
      openGate: "open gate",
      closeGate: "close gate",
      blockGate: "block gate", 
      unblockGate: "unblock gate", 
      autotuneSelected: "autotune selected", 
      autoTuneFailed: "autotune failed"
    },
    states: {
      [AttentionTypes.good]: "Running",
      [AttentionTypes.neutral]: "Off",
      [AttentionTypes.warning]: "Warning",
      [AttentionTypes.alert]: "Alert"
    },
    createSystem: {
      createNewSystem: "create new system", 
      systemName: "system name", 
      systemType: "system type", 
      systemNameMissing: "system name missing", 
      systemTypeMissing: "system type missing", 
      systemLimitReached: "system limit reached", 
      createSystem: "create system" 
    },
    blueprint: {
      blueprint: "blueprint", 
      upload: "upload", 
      wrongType: "Error processing file", 
      wrongSize: "File is too large (max 500 kB)", 
      pleaseDropImage: "Please drop a JPEG file", 
      pleaseSelectImage: "Please select a JPEG file", 
      dropImage: "Drag and drop your blueprint here", 
      browseImage: "Or browse it from your computer", 
      chooseFile: "Choose file",  
      chooseAgain: "choose again" 
    }
  },
  // #endregion
  
  // #region | Motor Specs 
  motorSpecs: { 
    general: {
      skipCnt: "skip count",
      skipTime: "skip time",
      powerConsumption: "power consumption",
      calibrationValue: "calibration value",
      rotationTime: "rotation time",
      statusMode: "status mode",
      noSkip: "No Skip",
      noPowerConsumption: "No Power Consumption",
      noCalibrationValue: "No Calibration Value",
      noRotationTime: "No Rotation Time",
      noStatusMode: "No Status ode",
      pending: "pending",
      activated: "activated",
      skippedUntil: "Skipped until",
      noLiveData: "No live data"
    },
    terminalTypes: {
      input: "Input", 
      output: "Output", 
      buttonInput: "Button Input", 
      gateSensorInput: "Gate Sensor Input", 
      digitalInput: "Digital Input", 
      waterOutput: "Water Output", 
      inputMotor: "Input Motor", 
      cupMotorOutput: "Cup Motor Output", 
      cupMotorInput: "Cup Motor Input", 
      gateMotorOutput: "Gate Motor Output", 
      gateMotorInput: "Gate Motor Input", 
      rfidReader: "RFID Reader", 
      rfidReaderInput: "RFID Reader Input", 
      rfidReaderDeviceId: "RFID Reader Device ID", 
      sensorP: "Sensor P", 
      defaultMotor: "def. motor",
      locationFeeder: "lf motor",
      activator: "activator",
      water: "wand",
    },
    terminalProgrammed: {
      disabled: "Disabled",
      calibration: "Calibration",
      feedingOnFeedingTimes: "Feeding on feeding times",
      motorPassive: "Motor passive"
    }
  },
  // #endregion

  // #region | Params
  params: {
    animal: "Animal",
    animalId: "Animal No.",
    animal_number: "Animal No.", 
    location: "Location",
    location_id: "Location", 
    feedCurve: "Feed Curve", 
    feedCurveId: "Foderkurve",
    group: "Group",
    animal_group_id: "Group", 
    condition: "Condition",
    removeAnimals: "Move animals",
    resetTotalConsumed: "Reset total consumed",
    manualFeedStart: "Manual feed start",
    clearCalendarEvents: "Empty alendar events",
    insemination: "Insemination",
    weaning: "Weaning",
    farrowing: "Farrowing",
    pregnancyCheck: "Pregnancy Check",
    birthDate: "Birth Date",
    pregnant: "Pregnant",
    responderNo: "Responder No.",
    responderNumber: "Responder No.", 
    lifeNo: "Life No.",
    life_number: "Life No.", 
    animalType: "Animal Type",
    milestone: "Milestone",
    milestone_id: "Current milestone", 
    milestone_day: "Milestone day", 
    system: "System",
    system_id: "System", 
    excess_remaining: "Missing more than",
    animalRemainingToday: "Remaining today", 
    animalRemainingYesterday: "Remaining yesterday", 
    animalConsumedToday: "Consumed today", 
    animalConsumedYesterday: "Consumed yesterday", 
    animalMilestoneDay: "Current milestone day", 
    animalCycleDayTotal: "Total cycle day", 
    section: "Section", 
    reset_consumption: "Reset consumption",
  },
  negativeParams: {
    animal: "No Animal",
    animals: "No Animals",
    animalId: "No Animal No.",
    location: "No Location",
    feedCurve: "No Feed Curve",
    group: "No Group",
    condition: "No Condition",
    component: "No Component",
    birthDate: "No Birth Date",
    pregnant: "Not Pregnant",
    responderNo: "No Responder No.",
    lifeNo: "No Life No.",
    animalType: "No Animal Type",
    milestone: "No Milestone",
    system: "No System",
    ds: "No DS",
    energy: "No energy",
    limit: "No limit",
    gramPerMinute: "No gram per minute",
    priority: "No priority",
    protein: "No protein",
  },
  // #endregion

  // #region | Configs
  configs: {
    stationStatus: {
      creation: "Creation",
      init: "Initializing",
      termCheck: "Term Check",
      calibrate: "Calibrate",
      idle: "Idle",
      waitingTag: "Waiting Tag",
      fetchFeeding: "Fetch Feeding",
      oneFeeding: "1 Feeding",
      spray: "Spray",
      feeding: "Feeding",
      waitingLeave: "Waiting Leave",
      blocked: "Blocked",
      disabled: "Disabled",
      error: "Error",
      end: "End"
    },
    feedMotor: {
      init: "Initilazing",
      idle: "Idle",
      running: "Running",
      bookCal: "Book Calibrate",
      bookEmpty: "Book Empty",
      starting: "Starting",
      cal: "Calibrate",
      empty: "Empty",
      end: "End",
      retry: "Retry",
      safetyOne: "Safety 1",
      safetyTwo: "Safety 2",
      safetyThree: "Safety 3",
      error: "Error"
    },
    gateMotor: {
      unknown: "Unknown",
      noGate: "No Gate",
      gateClosed: "Gate closed",
      gateClosing: "Gate closing",
      gateOpen: "Gate open",
      gateOpening: "Gate opening"
    }
  },
  // #endregion
  
  // #region | Feed
  feed: {
    general: {
      feed: "feed",
      feeding: "feeding",
      remainingToday: "Remaining today",
      remainingYesterday: "Remaining yesterday",
      waterUseToday: "Water use today",
      notFed: "fed <20% last two days",
      feedLastDays: "last 10 days",
      currentProgress: "current progress",
      fedLastPeriod: "fed last period",
      fedTotal: "fed total",
      feedConsumption: "feed consumption",
      feedBalance: "feed balance",
      consumedToday: "consumed today",
      consumedYesterday: "consumed yesterday",
      expectedConsumption: "Expected Consumption", 
      actualConsumption: "Actual Consumption"
    },
    feedCurve: {
      feedCurve: "Feed Curve",
      active: "active",
      noFeedCurve: "No feed curve found",
      default: "default",
      minFeedSpeed: "minimum feed speed (g/min)",
      maxFeedSpeed: "maximum feed speed (g/min)",
      feedSpeed: "feed speed",
    },
    feedCorrection: {
      increased: "increased",
      decreased: "decreased",
      disabled: "disabled",
      feedCorrection: "Feed Correction",
      feedCorrections: "Feed Corrections",
    },
    feedSkip: {
      feedSkip: "feed skip",
      skipFeeding: "skip feeding",
      noSkip: "no feed skip",
      skipForNow: "for now",
      planSkip: "plan",
      planFeedSkip: "plan feed skip",
      standardSkip: "standard",
      startFeeding: "start feeding",
      invalidDay: "invalid day",
      invalidTime: "invalid time",
      endDateBeforeStartDate: "the end date occurs before the start date",
      endTimeBeforeStartTime: "the end time occurs before the start time",
      timeSpan: "time span",
      timeAmount: "time amount",
      startDate: "start date",
      endDate: "end date",
      startTime: "start time",
      endTime: "end time",
      plannedSkip: "planned skip",
      recentFeedSkipSuccess: "Recent feed skip success status",
    }
  },
  // #endregion

  // #region | Login Flow
  loginFlow: {
    def: {
      fullView: "full view",
      focus_view: "focus view",
      goToSiteList: "Go to Site List",
      switchTofocus_view: "Switch to Focus View",
      switchToFullView: "Switch to Full View"
    },
    login: {
      login: "log in",
      logOut: "Log Out",
      welcomeBack: "welcome back",
      notRegisteredYet: "Not registered yet",
      createNewuser: "create new user",
      forgotPassword: "Forgot password",
      resetPassword: "reset password",
      missingUserName: "user name is missing",
      missingPassword: "password is missing",
      couldNotLogin: "failed to log in",
      noSitesFound: "no sites found"
    },
    forgotPassword: {
      forgotPassword: "forgot password",
      resetPassword: "reset password",
      text: "If there is no email assigned to the user name, please contact the support for further help.",
      text2: "Please don't close this window before the reset process is done.",
      noEmail: "No email assigned",
      contactSupport: "contact support",
      usernameRequired: "username required",
      noUsernameFound: "username does not excist"
    },
    resetPassword: {
      resetPassword: "reset password",
      text: `A temporary code has been sent to your email. Please write it below to create a new password.`,
      temporaryCode: "Temporary code",
      newPassword: "New password",
      repeatPassword: "Repeat new password",
      createNewPassword: "create new password",
      contactSupport: "contact support",
      noPasswordRevieved: "Didn't recieve a temporary code",
      newPasswordFail: "failed to create new password"
    },
    createUser: {
      newUser: "new user",
      missingUserName: "user name is missing",
      missingPassword: "password is missing",
      missingRepeatPassword: "please repeat password",
      passwordMismatch: "password mismatch",
      success: "success"
    },
    chooseSite: {
      chooseSite: "choose site",
      siteName: "site name",
      domain: "domain",
      id: "ID",
      tools: "tools"
    }
  },
  // #endregion

  // #region | Widgets
  widgets: {
    general: {
      noWidgets: "There is at the moment no widgets on this page.",
      widgetOptions: "widget options",
      manageWidgets: "manage",
      name: "Name",
      type: "Type",
      widgetPriority: "Priority",
      createNew: "create new",
      copyExisting: "copy existing",
    },
    widgetTypes: {
      autoReports: "Auto Reports",
      autoReportsAndMore: "Auto Reports etc.",
      graph: "Graph",
      progress: "Progress Circles",
    },
    graph: {
      noGraphSelected: "No graph selected",
      graphIncludesStart: "The graph includes all animals",
      graphIncludesEnd: "that has feed consumption data",
      animalsToInclude: "Animals to include based on system",
      last10Days: "Last 10 days feed consumption",
      last10DaysComponent: "Last 10 days feed consumption by component",
    },
    autoReports: {
      autoReports: "Auto Reports",
      navigatedFromSystem: "Navigated from system",
      add: "Add auto report",
      addExisting: "add existing"
    }
  },
  // #endregion

  // #region | Penlist
  penList: {
    basicDisclaimer: "Hold the mouse on a value to see column type",
    editDisclaimer: "Edit an animal by selecting new values",
    addDisclaimer: "Add an animal from the dropdown or remove it again on the bin icon",
    moveDisclaimer: "Move an animal to a new location from the dropdown or remove it from any location on the bin icon",
  },
  // #endregion

  // #region | Feed Curve pages
  feedCurvePages: {
    feedCurves: {
      copyFeedCurve: "copy feed curve",
      createFeedCurve: "create feed curve",
      createFeedCurveFromScratch: "Create feed curve from scratch",
      feedCurveDetails: "feed curve details",
      newFeedCurve: "new feed curve",
      feedCurveName: "feed curve name",
      fromFeedCurve: "from feed curve",
      feedCurveNameMissing: "feed curve name missing",
      goToFeedCurvePage: "go to feedcurve page" 
    },
    components: {
      components: "components",
      emptyText: "No components found",
      name: "Component name",
      readyMixture: "Ready to Use",
      priority: "Priority",
      ds: "DS",
      energy: "Energy",
      protein: "Protein",
      gramPerMinute: "Gram per minute",
      limit: "Limit",
      newComponent: "new component"
    },
    feedCurve: {
      spreading: "spreading",
      spreadings: "Spreadings",
      noSpreading: "No Spreading",
      settings: "settings",
      day: "day",
      watchFeedCurve: "watch feed curve",
      doNotPassFeed: "Do not pass feed",
      passFeed: "Pass feed",
      stimuli: "Stimuli",
      noStimuli: "No stimuli",
      addStimuli: "Add stimuli",
      singleStimuli: "Single stimuli",
      repeatStimuli: "Repeat stimuli",
      maxAmount: "max period amount (kg)",
      remainingFeed: "remaining feed",
      maxFeedToPass: "max KG to pass",
      max: "max",
      feeding: "feeding",
      feedings: "feedings",
      feedStimuli: "feed stimuli",
      minutesApart: "minutes apart",
      addTime: "add time",
      saveChanges: "save changes",
      resetChanges: "reset changes",
      feedCurveLenght: "Lenght",
      feedLimit: "Feed Limit",
      animalCount: "Animals",
      consumedToday: "Consumed Today",
      usage: "current usage", 
      unknownMilestoneAndDay: "Ukendt milepæl og dag", 
      deleteFeedcurve: "delete feedcurve", 
      confirmDelete: "Are you sure you want to delete this feedcurve", 
      noFeedcurves: "No feed curves found" 
    }
  },
  // #endregion

  // #region | Animal pages
  animalPages: {
    animals: {
      animals: "animals",
      emptyText: "No animals found",
      quickEntry: "quick entry",
      newAnimal: "new animal",
      viewChanges: "view changes",
      action: "action",
      selectAnimals: "select animals",
      missingAnimalNo: "animal no. is missing",
      missingResponderNo: "responder no. is missing",
      kgFedMore: "KG fed more than expected",
      noAnimalsMatchTheSelection: "No animals match the selection",
      responderLengt: "the responder number must be 15 characters", 
      lifeNoLengt: "the life number must not exceed 9 characters", 
      columns: "Columns", 
      priority: "Priority", 
      tablePreferences: "table preferences", 
      resetConsumptionDisclaimer: "Note: reset consumption only available for ESF",
    },
    animalGroups: {
      group: "group",
      numberOfAnimals: "Number of Animals",
      createGroup: "create group",
      newGroup: "new group",
      groupName: "group name",
    },
    animal: {
      animal: "animal",
      basicInfo: "basic info",
      noAnimalSelected: "No animal selected",
      noAnimalsSelected: "No animals selected",
      addAnimal: "add animal",
      addAnimalToPen: "add animal to pen",
      pen: "Pen",
      moveAnimal: "move animal",
      moveAnimals: "move animals",
      moveAnimalFromPen: "move animal to pen",
      goToAnimal: "go to animal page",
      totalCycleDay: "total cycle day",
      marking: "marking",
      noTimeline: "No timeline found",
      timeline: "timeline",
      viewTimeline: "view timeline",
      born: "born",
      timelineShows: "timeline shows parity",
      parity: "parity",
      deleteAnimal: "delete animal",
      deleteConfirm: "Are you sure you want to delete this Animal?" 
    }
  },
  // #endregion

  // #region | Report pages
  reportPages: {
    reports: {
      template: "Template",
      templateName: "Template Name",
      addTemplate: "add template",
      copyTemplate: "copy template",
      createReport: "create report",
      createNewReport: "Start a new report from scratch",
      newTemplate: "new template",
      newReport: "new report",
      dataLevel: "Data Level",
      filterParameter: "Filter Parameter",
      dataParameter: "data parameter",
      reportName: "report name",
      archiveReport: "archive report",
      startDate: "start date",
      endDate: "end date",
      showInReport: "Show in Report",
      fromTemplate: "from template",
      noReportFound: "no report found",
      noDataParameterFound: "no data parameter found",
      unknownCondition: "unknown condition",
      unknownAnimalGroup: "ynknown group",
      noFilterParameterFound: "no filter parameter found",
      saveAsTemplate: "save as template",
    },
    manageTemplates: { 
      templateOptions: "template options", 
      manageTemplates: "manage", 
      copyExisting: "copy existing", 
      noTemplates: "There is at the moment no widgets on this page.", 
    }, 
    report: {
      report: "report",
      editReport: "edit report",
      unArchiveReport: "unarchive report",
      saveAsTemplate: "save as template",
      noReport: "no report found",
      noReports: "No reports found",
      deleteReport: "delete report", 
      deleteConfirm: "Are you sure you want to delete this report?" 
    },
    reportColumn: {
      system: "System",
      system_id: "System",
      animal_id: "Animal",
      animal_button: "Animal",
      location: "Location",
      location_id: "Location",
      section_id: "Section",
      section: "Section",
      feedcurve_id: "Feedcurve",
      feedCurveId: "Feedcurve",
      animal_number: "Animal no.",
      cycle: "Cycle",
      correction: "Correction",
      feedcurve_milestones: "Feedcurve Milestones",
      milestone_day: "Milestone Day",
      condition: "Condition",
      animal_type: "Animal Type",
      responder_number: "Responder no.",
      life_number: "Life no.",
      birthday: "Birthday",
      animal_group_name: "Group",
      milestone_name: "Milestone",
      milestone_id: "Milestone",
      animal_group_id: "Group",
      group_id: "Group",
      group_name: "Group",
      system_id_for_report: "System ID for Reports",
      system_name: "System",
      totalPeriodConsumption: "Total Period Consumption",
      consumed: "Consumed"
    },
    archive: {
      archive: "archive",
      filterByNumber: "report number",
      filterByName: "report name alphabetical",
      archivedReport: "Archived report",
      noStartDateFound: "No start date found",
      noEndDateFound: "No end date found",
    },
    errorMessages: { 
      missingName: "missing name", 
      missingStartDate: "missing start date", 
      missingEndDate: "missing end date", 
      missingDataLevel: "missing data level", 
      missingFilterParameters: "missing filter parameters", 
    } 
  },
  // #endregion

  // #region | Logbook pages
  logPages: { 
    logbook: { 
      problem: "Problem", 
      warning: "Warning", 
      info: "Info", 
      debug: "Debug", 
      system: "System", 
      motor: "Motor", 
      animal: "Animal", 
      time: "time", 
      level: "level", 
      type: "type", 
      message: "message", 
      location: "location", 
      controller: "controller", 
      allControllers: "all controllers", 
      controllerName: "controller name", 
      deviceName: "device name", 
      lanControllers: "lan controllers", 
      getLog: "get log", 
      noLogsAvailable: "No logs found", 
      responder: "responder", 
    }, 
  }, 
  // #endregion

  // #region | Global Settings pages
  globalSettingsPages: {
    globalSettings: {
      imperial: "Imperial",
      metric: "Metric",
      saveChanges: "save changes",
      discardChanges: "discard changes",
      userManagement: "user management",
      workerManagement: "worker management", 
      timeZone: "time zone",
      feedDayStart: "feed day start",
      remove: "remove",
      emailAttentionDisclaimerWorker: "Choose which systems your worker should receive attentions from", 
      emailAttentionDisclaimerUser: "Choose which systems you want to receive attentions from", 
      settingsFor: "settings for",
      systemNotifications: "system notifications" 
    }
  },
  // #endregion

  // #region | Location Feeder Pages
  locationFeederPages: {
    locationFeeder: {
      sections: "sections",
      pens: "pens",
      animals: "animals",
      sectionNo: "Section No.",
      pen: "Pen",
    },
    sections: {
      section: "Section",
      sections: "sections",
      map: "map",
      animalAmount: "number of animals",
      penValueHeaders: "hold the mouse on a value to see column type",
      sectionNotFound: "section not found",
      emptyPen: "Empty pen",
      feeder: "feeder",
      inThisPen: "in this pen",
      activations: "activations",
      lastActivated: "last activated",
      newSection: "new section",
      sectionName: "section name",
      firstPenNo: "first pen no.",
      penAmount: "number of pens",
      clickOnPen: "Click on a pen to add it or remove it again.",
      penContent: "pen content",
      feederOnly: "Feeder only",
      water: "Water",
      activator: "Activator",
      feederOutput: "Feeder Output",
      waterOutput: "Water Output",
      activatorInput: "Activator Input",
      since: "since",
      redirect: "This will redirect you to the animal page.",
      expand: "expand",
      collapse: "collapse",
      noSections: "No sections found",
      noAnimal: "No Animal", 
      editSection: "edit section", 
      clickPen: "Click every pen you want to edit", 
      clicStation: "Click every station you want to edit", 
      deleteSectionConfirm: "Are you sure you want to delete this section", 
      priority: "Priority", 
      sectionNameMissing: "section name missing", 
      pen: "Pen", 
    },
    settings: {
      dailyRotation: "daily rotation",
      dailyRotationDisclaimer: "NB: If the location is empty or the animal has no feed curve assigned, the motor will perform a daily rotation for service purposes.",
      feedInSilos: "feed in silos",
      attentionLimit: "attention limit",
      feedAmount: "feed amount", 
      defFeedAmount: "default feed amount (g)", 
      deleteSystem: "delete system", 
      deleteDisclaimer: "Are you sure you want to delete this system", 
      systemName: "system name" 
    }
  },
  // #endregion

  // #region | ESF Walk Through Pages
  esfWalkThroughPages: {
    esfWalkThrough: {
      pens: "pens", 
      station: "Station", 
      stations: "stations", 
      animals: "animals", 
      motor: "motor", 
      component: "component", 
      noComponent: "No component", 
      include: "include", 
    },
    sections: {
      pen: "pen", 
      pens: "pens", 
      station: "Station",
      stationFeeding: "feeding", 
      feedMotor: "feed motor",
      feedSensor: "feed sensor",
      gateMotor: "gate motor",
      gateSensor: "gate sensor",
      inThisStation: "in this station",
      previously: "previously",
      feedComponents: "feed components",
      stationLastDays: "last 10 days",
      stationLog: "log",
      noPens: "No pens found", 
      currentlyInThisPen: "currently in this pen", 
      animal: "Animal", 
      noAnimal: "No animal", 
      unknownAnimal: "Uknown animal", 
      fedToday: "fed today", 
      usesToday: "uses today", 
      stationsState: "station state", 
      available: "available", 
      consumed: "consumed", 
      number: "no", 
      water: "water", 
      waterAddedPrCup: "water added pr. cup", 
      waterDelay: "water delay", 
      gateAdjustment: "gate adjustment", 
      delayTimeClosingGate: "delay time closing gate", 
      indetificationValidTime: "identification valid time", 
      entryTime: "entry time", 
      feedMotors: "feed motors", 
      noFeedBlockTime: "no feed block time", 
      lastFeedBlockTime: "last feed block time", 
      motorComponents: "motor components", 
      motor: "motor", 
      missing: "missing", 
    },
    newSection: {
      firstStationNo: "first station no.", 
      firstColumnExit: "first column exit", 
      secondColumnExit: "second column exit", 
      numberOfFeeders: "Number of feeders", 
      water: "Water", 
      button: "Button", 
      waterOutput: "Water Output", 
      buttonInput: "Button Input", 
      feederOutput: "Feeder Output", 
      feederInput: "Feeder Input", 
      gateMotorOutput: "Gate Motor Output", 
      gateMotorInput: "Gate Motor Input", 
      gateSensor: "Gate Sensor", 
      newPen: "new pen", 
      penName: "pen name", 
      numberOfStations: "number of stations", 
      clickOnStation: "Click on a station to add it or remove it again.", 
      stationContent: "station content", 
      editPen: "edit pen", 
      clickStationToEdit: "Click every station you want to edit", 
      station: "Station", 
      penNameMissing: "pen name missing", 
      editFailed: "edit failed", 
      noStationsSelected: "no stations selected", 
      deletePenConfirm: "Are you sure you want to delete this pen", 
    },
    settings: {
    },
    systemControl: {

    }
  },
  // #endregion

  // #region | Focus View Pages
  focus_viewPages: {
    location: "location",
    system: "system",
    section: "section",
    inThisPen: "in this pen",
    today: "today",
    pen: "Pen",
    since: "since",
    day: "Day",
    moveAnimal: "move animal",
    newLocation: "new location",
    emptyPen: "Empty pen",
  }
  // #endregion
}
export default Texts